import { render, staticRenderFns } from "./MoneyInList.vue?vue&type=template&id=78a545c4&scoped=true"
import script from "./MoneyInList.vue?vue&type=script&lang=js"
export * from "./MoneyInList.vue?vue&type=script&lang=js"
import style0 from "./MoneyInList.vue?vue&type=style&index=0&id=78a545c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a545c4",
  null
  
)

export default component.exports